import { render, staticRenderFns } from "./uom-stock.vue?vue&type=template&id=4ac00537"
import script from "./uom-stock.vue?vue&type=script&lang=js"
export * from "./uom-stock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports